import styled from 'styled-components';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const TimeSettingsContainer = styled.div<{ $isActive?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: ${({ $isActive }) => ($isActive ? '90px' : 0)};
  overflow: hidden;
  transition: max-height 0.1s ease-in-out;
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  button {
    height: 56px;
  }
`;
